import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Scheduled from "./Scheduled";
import Escalated from "./Escalated";
import EngagementScheduleFilter from "modules/dashboards/engagement/EngagementScheduleFilter";
import { getFormattedStartDate, getFormattedEndDate } from "functionCall";
import { useMedRepBookings, useOverDueTask } from "./store";
import OverDueTask from "./OverDueTask";
import MedRepBookings from "./MedRepBookings";

function MedRepEngagement() {
  const { overDueTaskData, fetchOverDueTask } = useOverDueTask();
  const { fetchMedRepBookings, medRepBookingData } = useMedRepBookings();
  const { id } = useParams();
  const [overDue, setOverDue] = useState();


  const [startFilterDate, setStartFilterDate] = useState(
    getFormattedEndDate(7)
  );
  const [endFilterDate, setEndFilterDate] = useState(getFormattedStartDate());
  const clearDate = () => {
    setStartFilterDate(getFormattedEndDate(7));
    setEndFilterDate(getFormattedStartDate());
  };

  useEffect(() => {
    fetchOverDueTask(
      id,
      getFormattedEndDate(15) + `T18:30:00.000Z`,
      getFormattedEndDate(1) + `T18:29:59.999Z`
    );
    getFormattedEndDate(1) + `T18:29:59.999Z`;
    fetchMedRepBookings(
      id,
      getFormattedEndDate(1) + `T18:30:00.000Z`,
      getFormattedStartDate() + `T18:29:59.999Z`
    );
  }, []);

  useEffect(() => {
    setOverDue(overDueTaskData);
  }, [overDueTaskData]);

  useEffect(() => {}, [startFilterDate, endFilterDate]);

  return (
    <div>
      <div className="float-end mt-2 mb-3">
      <EngagementScheduleFilter
        setStartFilterDate={setStartFilterDate}
        setEndFilterDate={setEndFilterDate}
        clearDate={clearDate}
      />
      </div>
      <div className="d-flex gap-3 w-100 my-3">
        <div style={{ flex: 1.5 }}>
          <CardDiv component={<Scheduled />} title={"Scheduled Cases"} />
        </div>
        <div className="flex-1">
          <CardDiv component={<Escalated />} title={"Scheduled Cases"} />
        </div>
      </div>
      <div className="d-flex gap-3 my-3">
        <div className="flex-1">
          <CardDiv component={<div></div>} title={"Call data"} />
        </div>
        <div className="flex-1">
          <CardDiv component={<div></div>} title={"Cod orders count"} />
        </div>
        <div className="flex-1">
          <CardDiv component={<div></div>} title={"Engagement Summary"} />
        </div>
        <div className="flex-1">
          <CardDiv component={<div></div>} title={"In-Progress Orders"} />
        </div>
        <div className="flex-1">
          <CardDiv component={<div></div>} title={"Repeat Orders"} />
        </div>
      </div>
      <div className="my-3">
        <CardDiv
          component={<MedRepBookings medRepBookingData={medRepBookingData} />}
          title={"Bookings"}
        />
      </div>
      <div className="my-3">
        <CardDiv
          component={<OverDueTask tasks={overDue} />}
          title={"Overdue Tasks"}
        />
      </div>
    </div>
  );
}

export default MedRepEngagement;
